/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import MagazineHeaderCard from "../../../../arrow-components/src/components/Rows/MagazineHeaderCard";

export const MagazineIssuesPage = ({ data = {}, config = {} }) => {
  const magazineData = data.magazines[0];
  const { collection } = magazineData[0];
  const rowConfig = get(config, ["pagebuilder-config", "magazine-issues", "rows", "0", "config"], config);

  return (
    <div className="component-wrapper" style={{ overflow: "inherit" }}>
      <MagazineHeaderCard collection={collection} config={rowConfig} />
    </div>
  );
};

MagazineIssuesPage.propTypes = {
  data: PropTypes.shape({ magazines: PropTypes.shape({ collection: PropTypes.object }) }),
  config: PropTypes.object
};
